// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_c8-0";
export var actionModalContentContainer = "_c8-1";
export var createTagButton = "_c8-2";
export var footerContainer = "_c8-7";
export var fullWidthDivider = "_c8-3";
export var hasCreateTagButton = "_c8-4";
export var noCreateTagButton = "_c8-5";
export var tagsContainer = "_c8-6";
export var tagsModalContentContainer = "_c8-8";